import { NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { EMAIL_REGEX, ZIP_REGEX } from '@constants/app.constants';
import { TEMPLATE_CONSTANT } from '@constants/template.constants';
import { WidgetTemplateModel } from '@models/widget-template.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CalioAddRequiredPipe } from '@pipes/calio-add-required.pipe';
import { CalioMeetingTemplatePipe } from '@pipes/calio-meeting-template.pipe';
import { CalioTranslateResolverPipe } from '@pipes/calio-translate-resolver.pipe';
import { CalioTranslationPipe } from '@pipes/calio-translation.pipe';
import { BookingService } from '@services/feature/booking.service';
import { WidgetService } from '@services/feature/widget.service';
import { LoggerService } from '@services/utils/logger.service';

const pipes = [CalioAddRequiredPipe, CalioTranslationPipe, CalioMeetingTemplatePipe, CalioTranslateResolverPipe];
const modules = [FormsModule, TranslateModule];

@Component({
  selector: 'app-survey-customer-form',
  templateUrl: './survey-customer-form.component.html',
  styleUrls: ['./survey-customer-form.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [NgClass, ...pipes, ...modules]
})
export class SurveyCustomerFormComponent implements OnInit {

  private bookingService = inject(BookingService);
  private widgetService = inject(WidgetService);
  private translate = inject(TranslateService);
  private destroyRef = inject(DestroyRef);

  protected disableEmailField = false;
  protected lang: string;
  protected customerFields = ['prename', 'lastname', 'email'];
  protected widgetTemplates: WidgetTemplateModel[];

  protected readonly emailRegex = EMAIL_REGEX;
  protected readonly zipRegex = ZIP_REGEX;
  protected readonly templateConstant = TEMPLATE_CONSTANT;

  constructor() {
    this.lang = this.translate.getFallbackLang();
  }

  ngOnInit(): void {
    if (this.widgetService.customerConfData.email) {
      this.disableEmailField = true;
    }

    if (this.widgetService.widgetConf.context?.ask_customer_city === 1) {
      this.customerFields.push('city');
    }

    if (this.widgetService.widgetConf.context?.ask_customer_zip === 1) {
      this.customerFields.push('zip');
    }
    this.getWidgetTemplates();
  }

  protected onZipBlur(): void {
    if (this.widgetService.customerConfData.zip) {
      this.widgetService.customerConfData.zip = this.widgetService.customerConfData.zip.trim().toUpperCase().replace(/\s+/g, ' ');
    }
  }

  private getWidgetTemplates(): void {
    this.bookingService.getWidgetTemplates()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: templates => this.widgetTemplates = templates,
        error: (error: HttpErrorResponse) => LoggerService.error(error)
      });
  }
}
